import * as React from 'react';
import { useRef } from 'react';

import { getCmsLocaleString } from 'js/lib/language';
import { useLocation } from 'js/lib/useRouter';

export type PromoTemplateContextState = {
  isPreview: boolean;
  locale: string;
  isFirstButtonCheckActionParamsRef: React.MutableRefObject<boolean>;
};

export const PromoTemplateContext = React.createContext<PromoTemplateContextState>({
  isPreview: false,
} as PromoTemplateContextState);

export const usePromoTemplateContext = () => React.useContext(PromoTemplateContext);

export const PromoTemplateProvider = ({ children }: React.PropsWithChildren) => {
  const { query } = useLocation();
  const isFirstButtonCheckActionParamsRef = useRef<boolean>(false);
  const isPreview = !!query.preview;
  const locale = query.locale || getCmsLocaleString() || 'en-US';

  return (
    <PromoTemplateContext.Provider value={{ isPreview, locale, isFirstButtonCheckActionParamsRef }}>
      {children}
    </PromoTemplateContext.Provider>
  );
};
